import { Field, Form, Formik, useFormikContext } from "formik";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import {
  IAssetDownlink,
  ISelectOption,
} from "../../../models/response/ITruckResponse";
import LoaderButton from "../../../shared-components/Button/LoaderButton";
import DraggableModal from "../../../shared-components/Draggable/DraggableModal";
import FormikFormInputMultipleSelect from "../../../shared-components/FormikFormHandlers/formik-form-multi-select-input";
import FormikFormInput from "../../../shared-components/FormikFormHandlers/FormikFormInput";
import { selectAssetIdValidateSchema } from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import Label from "../../../shared-components/label/label";
import { useState } from "react";

interface IProps {
  submitHandler: (values: IAssetDownlink, aptType: number) => void;
  onModalClosed: () => void;
  actionInProgress: boolean;
  assetOptions: ISelectOption[];
  initialValues: { AssetDownlinkRequestItemArrayList: ISelectOption[] };
}

const SelectAssetIdForm = (props: IProps) => {
  const { submitHandler, onModalClosed, initialValues, actionInProgress } =
    props;

  const [apiType, setApiType] = useState<number>(0);

  const FormObserver: React.FC = () => {
    const { values } = useFormikContext<any>();
    return null;
  };

  return (
    <>
      <Modal
        className="add-user-modal add-assets-modal"
        show={true}
        centered
        dialogAs={DraggableModal}
      >
        <Modal.Header>
          <Modal.Title>
            <FormattedMessage id="downlink_asset_info" />
          </Modal.Title>
          <div onClick={onModalClosed} className="icons8-close">
            <span className="material-symbols-outlined fs-5 text-dark">
              close
            </span>
          </div>
        </Modal.Header>
        <Formik
          validationSchema={selectAssetIdValidateSchema}
          initialValues={initialValues}
          enableReinitialize
          onSubmit={async (values) => {
            let isAllOptionSelected =
              values.AssetDownlinkRequestItemArrayList.filter(
                (gp: ISelectOption) => gp.id === -1
              );
            let selectedGroupIdList: Array<ISelectOption> =
              isAllOptionSelected.length > 0
                ? [...props.assetOptions]
                    .filter((as) => as.id !== -1)
                    .map((gp: ISelectOption) => gp)
                : [...values.AssetDownlinkRequestItemArrayList].map(
                    (gp: ISelectOption) => gp
                  );
            let tempValue = {
              AssetDownlinkRequestItemArrayList: selectedGroupIdList.map(
                (asset) => {
                  return { ...asset.data };
                }
              ),
            };
            // let tempValue = {
            //   AssetDownlinkRequestItemArrayList:
            //     values.AssetDownlinkRequestItemArrayList.map((asset) => {
            //       return { ...asset.data };
            //     }),
            // };
            props.submitHandler(tempValue, apiType);
            // }
          }}
        >
          {({ values }) => (
            <Form className="user-form p-3" noValidate>
              <FormObserver />
              <Modal.Body>
                <Row className="mb-3 form-group d-flex align-items-center">
                  <Col xs={12}>
                    <Label
                      className="label-style col-sm-4 col-form-label"
                      required={true}
                      label="select_assests"
                    />
                  </Col>
                  <Col xs={12}>
                    <Field
                      name="AssetDownlinkRequestItemArrayList"
                      className="react-select-parent"
                      isMulti={true}
                      isSearchable={true}
                      isDisabled={false}
                      isLoading={false}
                      isClearable={true}
                      isSelectAsset={+true}
                      options={
                        values?.AssetDownlinkRequestItemArrayList?.length > 0
                          ? values?.AssetDownlinkRequestItemArrayList?.findIndex(
                              (item: any) => item.id === -1
                            ) !== -1
                            ? [props.assetOptions[0]]
                            : props.assetOptions.filter(
                                (item: any) => item.id !== -1
                              )
                          : props.assetOptions ?? []
                      }
                      as={FormikFormInputMultipleSelect}
                    />
                  </Col>
                </Row>
                <Row className="mb-3 form-group d-flex align-items-center">
                  <b>
                    <span className="pe-1">
                      {values?.AssetDownlinkRequestItemArrayList?.findIndex(
                        (item: any) => item.id === -1
                      ) !== -1
                        ? "All"
                        : values.AssetDownlinkRequestItemArrayList.length}
                    </span>
                    <FormattedMessage id="assets_selected" />
                  </b>
                </Row>
                {/* {
                  err &&
                  <span data-testid="testError" className= "text-danger errorMessage">
                    <FormattedMessage id="please_select_at_least_1_field" />
                  </span>
                } */}
              </Modal.Body>
              <div className="modal-footer  border-0">
                <div className="m-auto">
                  <LoaderButton
                    type="submit"
                    isLoading={actionInProgress}
                    disabled={actionInProgress}
                    text="Send Write Message"
                    onClick={() => setApiType(0)}
                  />
                  <LoaderButton
                    type="submit"
                    className="ms-2"
                    isLoading={actionInProgress}
                    disabled={actionInProgress}
                    text="Send Delete message"
                    onClick={() => setApiType(1)}
                  />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default SelectAssetIdForm;
